import { customerService, shopifyService } from "../../services";
import { custom, success } from "./actionsUtilities";
import {
  beautifyDateForExport,
  beautifyStringForImport,
  customToast,
  downloadCSV,
  getPaginationFilterParamsFromGridState,
  getSellTradeCustomerObject,
  updateCustomerCreditOnCarts,
} from "../../shared/utility";
import { shopifyActions, systemActions, transactionActions } from "../actions";
import {
  toastType,
  toastMessages,
  systemConstants,
  customerConstants,
  routesPathConstants,
  defaultGridState,
  transactionConstants,
  globalConstants,
  COL_NAMES,
} from "../../constants";

//-------Add new customer
const addNewCustomer = (data, redirect = false) => {
  return (dispatch) => {
    dispatch(
      custom(customerConstants.ADD_CUSTOMER, systemConstants.SPINNER_ACTIVATE)
    );
    customerService
      .addNewCustomer(data)
      .then(
        (response) => {
          customToast(
            toastMessages.CUSTOMER_ADDED_SUCCESSFULLY,
            toastType.SUCCESS
          );
          if (redirect) {
            dispatch(
              systemActions.pageRedireaction(routesPathConstants.CUSTOMERS)
            );
          }
          dispatch(transactionActions.toggleAddCustomerModal(false));
          dispatch(getPaginationCustomers(data.companyId, data?.store?.id));
          dispatch(custom(null, customerConstants.SET_CUSTOMER_DROPDOWN_KEY));
          // If added from order details modal then attach this new customer with the order and refetch orders to update the customer details in modal UI
          if (
            (data.shopifyOrdersCallBackConfig?.isRefetchOrdersOnSave ||
              data.shopifyOrdersCallBackConfig?.isRefetchTransactionsOnSave) &&
            response?.data?.data?.id
          ) {
            dispatch(
              shopifyActions.updateShopifyOrderCustomer(
                data?.store?.id,
                {
                  ...data.shopifyOrdersCallBackConfig?.orderDetail,
                  customer: response?.data?.data,
                },
                data.shopifyOrdersCallBackConfig
              )
            );
          }
        },
        (error) => {
          customToast(error, toastType.ERROR);
        }
      )
      .finally(() => {
        dispatch(
          custom(
            customerConstants.ADD_CUSTOMER,
            systemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};
//-------Get all customer
const getAllCustomer = (companyId, storeId) => {
  return (dispatch) => {
    dispatch(
      custom(
        customerConstants.GET_ALL_CUSTOMERS,
        systemConstants.SPINNER_ACTIVATE
      )
    );
    customerService
      .getAllCustomer(companyId, storeId)
      .then(
        (response) => {
          dispatch(success(response, customerConstants.GET_ALL_CUSTOMERS));
        },
        (error) => {
          customToast(error, toastType.ERROR);
        }
      )
      .finally(() => {
        dispatch(
          custom(
            customerConstants.GET_ALL_CUSTOMERS,
            systemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

const getPaginationCustomers = (
  companyId,
  storeId,
  paginationFilters = getPaginationFilterParamsFromGridState(defaultGridState),
  isGuestCustomers = false
) => {
  return (dispatch) => {
    dispatch(
      custom(
        customerConstants.GET_PAGINATION_CUSTOMERS,
        systemConstants.SPINNER_ACTIVATE
      )
    );
    customerService
      .getPaginationCustomers(
        companyId,
        storeId,
        paginationFilters,
        isGuestCustomers
      )
      .then(
        (response) => {
          dispatch(
            success(response, customerConstants.GET_PAGINATION_CUSTOMERS)
          );
        },
        (error) => {
          customToast(error, toastType.ERROR);
        }
      )
      .finally(() => {
        dispatch(
          custom(
            customerConstants.GET_PAGINATION_CUSTOMERS,
            systemConstants.SPINNER_DEACTIVATE
          )
        );
        dispatch(custom(false, systemConstants.SET_IS_SERVER_SEARCH_LOADING));
      });
  };
};

//-------Delete Customer
const deleteCustomer = (id, companyId, storeId) => {
  return (dispatch) => {
    dispatch(
      custom(
        customerConstants.DELETE_CUSTOMER,
        systemConstants.SPINNER_ACTIVATE
      )
    );
    customerService
      .deleteCustomer(id, companyId, storeId)
      .then(
        () => {
          customToast(
            toastMessages.CUSTOMER_DELETED_SUCCESSFULLY,
            toastType.SUCCESS
          );
          dispatch(getPaginationCustomers(companyId, storeId));
        },
        (error) => {
          customToast(error, toastType.ERROR);
        }
      )
      .finally(() => {
        dispatch(
          custom(
            customerConstants.DELETE_CUSTOMER,
            systemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

//-------Update Customer
const updateCustomer = (data, redirect = false) => {
  return (dispatch) => {
    dispatch(
      custom(
        customerConstants.UPDATE_CUSTOMER,
        systemConstants.SPINNER_ACTIVATE
      )
    );
    customerService
      .updateCustomer(data)
      .then(
        (response) => {
          customToast(
            toastMessages.CUSTOMER_UPDATED_SUCCESSFULLY,
            toastType.SUCCESS
          );
          if (redirect) {
            dispatch(
              systemActions.pageRedireaction(routesPathConstants.CUSTOMERS)
            );
          }
          dispatch(getCustomerById(data.companyId, data?.store?.id, data.id));
          dispatch(custom(null, customerConstants.SET_CUSTOMER_DROPDOWN_KEY));
          dispatch(transactionActions.toggleAddCustomerModal(false));
          if (
            (data.shopifyOrdersCallBackConfig?.isRefetchOrdersOnSave ||
              data.shopifyOrdersCallBackConfig?.isRefetchTransactionsOnSave) &&
            response?.data?.data?.id
          ) {
            shopifyService
              .getShopifyOrderById(
                data?.store?.id,
                data.shopifyOrdersCallBackConfig?.orderDetail?.id
              )
              .then((shopifyOrder) => {
                data.shopifyOrdersCallBackConfig?.callBackFuction(shopifyOrder);
              });
          }
        },
        (error) => {
          customToast(error, toastType.ERROR);
        }
      )
      .finally(() => {
        dispatch(
          custom(
            customerConstants.UPDATE_CUSTOMER,
            systemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

const transferCustomerCredit = (data) => {
  return (dispatch) => {
    dispatch(
      custom(
        customerConstants.UPDATE_CUSTOMER,
        systemConstants.SPINNER_ACTIVATE
      )
    );
    customerService
      .transferCustomerCredit(data)
      .then(
        (response) => {
          // Pass id if you want to update customer in sale/trade cart and Pass transactionId if you want to udpate the customer in backend saved Transaction (transfer credit on complete transaction screen)
          if (data.id) {
            customToast(
              toastMessages.CUSTOMER_UPDATED_SUCCESSFULLY,
              toastType.SUCCESS
            );
            dispatch(
              getCustomerById(
                data.companyId,
                data?.store?.id,
                data.id,
                data.transactionId
              )
            );
          }
          dispatch(
            custom(
              false,
              transactionConstants.SET_IS_TRANSFER_CUSTOMER_CREDIT_MODAL
            )
          );
        },
        (error) => {
          customToast(error, toastType.ERROR);
        }
      )
      .finally(() => {
        dispatch(
          custom(
            customerConstants.UPDATE_CUSTOMER,
            systemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

//-------Get customer by Id
const getCustomerById = (companyId, storeId, customerId, transactionId) => {
  return (dispatch) => {
    dispatch(
      custom(
        customerConstants.GET_CUSTOMER_BY_ID,
        systemConstants.SPINNER_ACTIVATE
      )
    );
    customerService
      .getCustomerById(companyId, storeId, customerId)
      .then(
        (response) => {
          updateCustomerCreditOnCarts(
            dispatch,
            storeId,
            response,
            transactionActions.setNewTradeData,
            transactionActions.setTransactionData
          );
          // transactionId if you want to udpate the customer in backend saved Transaction (transfer credit on complete transaction screen)
          if (transactionId) {
            const endPoint = String(transactionId).includes(
              globalConstants.TYPE_ID_TRA
            )
              ? "transaction"
              : "trade";
            dispatch(
              transactionActions.updateCustomerInTransactionHistory(
                { customer: getSellTradeCustomerObject(response) },
                {
                  storeId: storeId,
                  id: transactionId,
                },
                undefined,
                endPoint
              )
            );
          }
          dispatch(success(response, customerConstants.GET_CUSTOMER_BY_ID));
        },
        (error) => {
          customToast(error, toastType.ERROR);
        }
      )
      .finally(() => {
        dispatch(
          custom(
            customerConstants.GET_CUSTOMER_BY_ID,
            systemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};
//-------emptyCustomerById
const emptyCustomerById = () => {
  return (dispatch) => {
    dispatch(success({}, customerConstants.EMPTY_CUSTOMER_BY_ID));
  };
};

//-------Add new customer
const bulkUploadCustomers = (companyId, storeId, importCustomerMisc) => {
  const { validateCsvDataRes, handleHideModal } = importCustomerMisc;
  const invalidCustomersFileName = "Invalid_Customers";
  return (dispatch) => {
    dispatch(
      custom(
        customerConstants.BULK_UPLOAD_CUSTOMERS,
        systemConstants.SPINNER_ACTIVATE
      )
    );
    customerService
      .bulkUploadCustomers(companyId, storeId, validateCsvDataRes.validData)
      .then(
        (response) => {
          // showing toast and handeling download csv for invalid records
          let toastMessage =
            validateCsvDataRes.validData.length +
            customerConstants.CUSTOMERS_IMPORTED_SUCCESSFULLY;
          if (validateCsvDataRes.invalidData.length || response.data.length) {
            toastMessage =
              validateCsvDataRes.validData.length -
              response.data.length +
              customerConstants.CUSTOMERS_IMPORTED_SUCCESSFULLY +
              "; " +
              (validateCsvDataRes.invalidData.length + response.data.length) +
              customerConstants.CUSTOMERS_NOT_IMPORTED;
            // downloading the csv file of invalid records
            downloadCSV(
              [
                // front end filtered invalid data
                ...validateCsvDataRes.invalidData.map(
                  (invalidCustomerRecord) => ({
                    ...invalidCustomerRecord,
                  })
                ),
                // mapping the backend values used in front end csv file
                ...response.data.map((invalidCustomerRecord) => {
                  return {
                    [COL_NAMES.CUSTOMER_ID]:
                      invalidCustomerRecord.companyCustomerId,
                    [COL_NAMES.FIRST_NAME]: invalidCustomerRecord.firstName,
                    [COL_NAMES.LAST_NAME]: invalidCustomerRecord.lastName,
                    Email: invalidCustomerRecord.email,
                    [COL_NAMES.PHONE_NUMBER]: invalidCustomerRecord.mobile,
                    [COL_NAMES.ID_TYPE]:
                      invalidCustomerRecord.driverLicenseIdType,
                    [COL_NAMES.ID_NUMBER]: invalidCustomerRecord.driverLicense,
                    [COL_NAMES.DATE_OF_BIRTH]: beautifyDateForExport(
                      invalidCustomerRecord.dateOfBirth
                    ),
                    [COL_NAMES.EXPIRATION_DATE]: beautifyDateForExport(
                      invalidCustomerRecord.expirationDate
                    ),
                    [COL_NAMES.STREET_1]: beautifyStringForImport(
                      invalidCustomerRecord.line1
                    ),
                    [COL_NAMES.STREET_2]: beautifyStringForImport(
                      invalidCustomerRecord.line2
                    ),
                    City: beautifyStringForImport(invalidCustomerRecord.city),
                    State: beautifyStringForImport(invalidCustomerRecord.state),
                    Zip: beautifyStringForImport(invalidCustomerRecord.zip),
                    Notes: beautifyStringForImport(invalidCustomerRecord.note),
                    [COL_NAMES.CUSTOMER_CREDIT]:
                      invalidCustomerRecord.currentBalance,
                    [COL_NAMES.REJECTION_REASON]:
                      invalidCustomerRecord.errorMessage,
                  };
                }),
              ],
              invalidCustomersFileName
            );
          }
          customToast(toastMessage, toastType.SUCCESS);
          dispatch(getPaginationCustomers(companyId, storeId));
          handleHideModal();
        },
        (error) => {
          // if all rows are invalid, the backend may throw error of min 1 required so download the frotnend invalid rows as invalid file
          if (validateCsvDataRes?.invalidData?.length) {
            downloadCSV(
              structuredClone(validateCsvDataRes.invalidData),
              invalidCustomersFileName
            );
          }
          customToast(error, toastType.ERROR);
        }
      )
      .finally(() => {
        dispatch(
          custom(
            customerConstants.BULK_UPLOAD_CUSTOMERS,
            systemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

const emptyDuplicateRecords = () => {
  return (dispatch) => {
    dispatch(success([], customerConstants.BULK_UPLOAD_CUSTOMERS));
  };
};

//-------Export Authentication Actions
export const customerActions = {
  addNewCustomer,
  getAllCustomer,
  deleteCustomer,
  updateCustomer,
  getCustomerById,
  emptyCustomerById,
  bulkUploadCustomers,
  emptyDuplicateRecords,
  transferCustomerCredit,
  getPaginationCustomers,
};
